export default {
    setOperacao ( state, payload) {
        state.operacaoCaptacaoEmAberto = payload;
    },

    updateOperacao(state, payload) {
        state.operacaoCaptacaoEmAberto = payload;
        
    }
}